// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3703":"77539186","8912":"0dbe7a27"}[chunkId] + ".chunk.css";
};